// extracted by mini-css-extract-plugin
module.exports = {"root":"_3hKhI","link":"_2WRJO"};